import { AddMainBookmakerMapping as AddMainBookmakerMappingComponent } from './AddMainBookmakerMapping.component';
import { connector } from './AddMainBookmakerMapping.connector';

export const AddMainBookmakerMapping = connector(AddMainBookmakerMappingComponent);
